// extracted by mini-css-extract-plugin
export default {"container":"components-parity-insight-breakdown-value-loading-module__container"};